import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { ImagePickerComponent } from './image-picker.component';

@Component({
  selector: 'app-image-field',
  templateUrl: './image-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImagePickerComponent, MatButtonModule, MatIconModule, MatTooltipModule, TranslatePipe],
})
export class ImageFieldComponent {
  readonly currentImageName = input<string | null>(null);
  readonly currentImageUrl = input<string | null>(null);
  readonly fileSelected = output<File>();
  readonly cleared = output<void>();
}
